import React, { useState, useEffect } from 'react';
import s from './StudioStatement.module.css';
import portrait from '../../images/לירית לנגר פורטרט.webp';
import detail1 from '../../images/lirit-site-1.webp';
import detail2 from '../../images/lirit-site-2.webp';
import detail3 from '../../images/lirit-site-3.webp';
import detail4 from '../../images/lirit-site-4.webp';
import detail5 from '../../images/lirit-site-5.webp';
import detail6 from '../../images/lirit-site-6.webp';
import detail7 from '../../images/lirit-site-7.webp';
import detail8 from '../../images/lirit-site-8.webp';
import detail9 from '../../images/lirit-site-9.webp';
import detail10 from '../../images/lirit-site-10.webp';

const DETAILS = [
  detail1, detail2, detail3, detail4, detail5,
  detail6, detail7, detail8, detail9, detail10,
];

export default function StudioStatement() {
  const [detailIdx, setDetailIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setDetailIdx((i) => (i + 1) % DETAILS.length),
      4500
    );
    return () => clearInterval(id);
  }, []);

  return (
    <section className={s.section} id="about">
      <div className={s.inner}>
        <div className={s.visual}>
          <figure className={s.frame}>
            <img src={portrait} alt="לירית לנגר" loading="lazy" />
          </figure>
          <figure className={`${s.frame} ${s.frameB}`}>
            <div className={s.rotWrap}>
              {DETAILS.map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt=""
                  loading="lazy"
                  className={s.rotImg}
                  style={{ opacity: i === detailIdx ? 1 : 0 }}
                />
              ))}
            </div>
          </figure>
        </div>

        <div className={s.copy}>
          <h2 className={s.heading}>אודותי ואודות הסטודיו</h2>

          <p className={s.lead}>
            לירית לנגר, אדריכלית בוגרת בצלאל בעלת ניסיון של 16 שנים בתכנון ועיצוב
            פרויקטים איכותיים ומגוונים בקני מידה שונים. מתמחה בבנייה למגורים -
            מבתים פרטיים, נחלות, וילות ודירות יוקרה, ועד תכנון שכונות ומתחמי מגורים.
          </p>

          <p className={s.body}>
            מאמינה ופועלת על פי גישת ה-<strong>TOTAL DESIGN</strong>, המתייחסת לפרויקט
            כמכלול שלם שבו התכנון והעיצוב משתלבים ליצירת אמירה עיצובית מגובשת והרמונית.
          </p>

          <p className={s.body}>
            לנגר אדריכלות ועיצוב הוא סטודיו לתכנון אדריכלי המספק מענה מקיף לכל הצרכים
            האדריכליים והעיצוביים של הפרויקט תחת קורת גג אחת - מבניית התכנית האדריכלית
            המותאמת אישית על כל פרטיה ועיצוב המבנה על כל מבטיו, דרך תהליך הרישוי ועד
            לבחירות חומרי הגמר, תכנון פרטי נגרות וכל פרטי העיצוב הנדרשים להשלמת התמונה
            העיצובית המלאה, כולל ליווי מלא של תהליך הבנייה.
          </p>

          <blockquote className={s.quote}>
            מייצרים אדריכלות נכונה המותאמת לאנשים המשתמשים בה.
          </blockquote>

          <div className={s.signature}>
            <span className={s.sigLine} />
            <div>
              <p className={s.sigName}>לירית לנגר</p>
              <p className={s.sigRole}>אדריכלית ומעצבת פנים · מייסדת הסטודיו</p>
              <p className={s.sigEdu}>B.Arch באדריכלות, בצלאל - אקדמיה לאמנות ועיצוב ירושלים</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
